import { render } from "./SolutionDetailsView.vue?vue&type=template&id=988352fa&scoped=true"
import script from "./SolutionDetailsView.vue?vue&type=script&lang=js"
export * from "./SolutionDetailsView.vue?vue&type=script&lang=js"

import "./SolutionDetailsView.vue?vue&type=style&index=0&id=988352fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988352fa"]])

export default __exports__